export default function Terms() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-8">Terms & Conditions</h1>
      
      <section className="prose prose-slate max-w-none">
        <h2 className="text-2xl font-semibold mb-4">PREAMBLE</h2>
        <p className="mb-4">
          This website, DIYLegal (hereinafter "the WEBSITE"), provides users with the service of an automatic writing system for documents which may be sold individually or through a subscription on the WEBSITE, depending on the country for which the USER is requesting the documents. The services of the WEBSITE will hereinafter collectively be referred to as "SERVICES."
        </p>
        
        <p className="mb-6">
          The following provisions define the contractual rights and obligations of the operator of the WEBSITE, DIYLegal ("DIYLegal"), and the USERS (as hereinafter defined) of the WEBSITE. USER or USERS shall be defined as all individuals that access the WEBSITE, whether by surfing, reading, viewing, using, and/or purchasing the documents and/or subscribing to the services offered on the WEBSITE. The home page of the WEBSITE is located at the following URL: www.app.DIYLegal.com
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 1 - ACCESS, NAVIGATION AND CONTACT</h2>
        <p className="mb-4">
          Any access, use, subscriptions and/or purchases on the WEBSITE are available only for legal entities and natural persons of full age and capacity.
        </p>
        
        <h2 className="text-2xl font-semibold mb-4">ARTICLE 2 - LIABILITY</h2>
        <p className="mb-4">
          DIYLEGAL's sole and exclusive responsibility shall be in the specific content DIYLEGAL provides to USER through the WEBSITE and SERVICES. Any inaccurate, incomplete, or otherwise incorrect information added by the USER or incorrect usage of the WEBSITE and SERVICES (including, but not limited to, incorrect usage of documents purchased on the WEBSITE) shall be the exclusive responsibility of the USER, with no liability on the part of DIYLEGAL.
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 3 - INTELLECTUAL PROPERTY</h2>
        <p className="mb-4">
          All of the WEBSITE's elements (including ergonomics, texts, graphs, images, sounds, videos, programming elements, database - this list shall not be considered exhaustive), together or separately, are the exclusive property of DIYLEGAL, protected pursuant to the moral and patrimonial rights belonging to their author(s) under the provisions of Articles L. 111-1 and following of the Code of Intellectual Property.
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 4 - SUBSCRIPTION</h2>
        <p className="mb-4">
          USERS in certain countries may have the option to access the SERVICES by using a subscription in order to benefit from unlimited access to the catalog of templates and to create documents for the duration of the subscription.
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 5 - PRICE</h2>
        <h3 className="text-xl font-medium mb-3">5.1 Subscription</h3>
        <p className="mb-4">
          The WEBSITE may provide subscription services to USERS in certain nations. If subscription services are provided, the terms outlined in this subsection will apply to govern the subscription services.
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 6 - PAYMENT</h2>
        <h3 className="text-xl font-medium mb-3">6.1 Subscription</h3>
        <p className="mb-4">
          The terms in this subpart only apply if subscription services are available in the country where the USER is accessing the SERVICES.
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 7 – USER ACCOUNT</h2>
        <p className="mb-4">
          The registration on the WEBSITE is free and open to any legal entity or natural person of full age and capacity, with a valid and active email address.
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 8 - PERSONAL DATA</h2>
        <h3 className="text-xl font-medium mb-3">8.1 Personal data collected</h3>
        <p className="mb-4">
          DIYLEGAL will securely collect the following personal data when a USER purchases a document or monthly subscription.
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 9 - SEVERABILITY OF THE PROVISIONS</h2>
        <p className="mb-4">
          The invalidity of one or more of these provisions does not invalidate any other provision within these Terms And Conditions. The remainder of the provisions, which are still valid, shall remain in full and force and effect.
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 10 – WAIVER</h2>
        <p className="mb-4">
          Should DIYLEGAL fail to enforce one or more of the provisions of this document, it shall not entitle the USER not to comply with that provision or any other provision of these Terms And Conditions, and shall not constitute or be deemed a final waiver of the assertion of DIYLEGAL's rights.
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 11 - AMENDMENT TO THE GENERAL TERMS AND CONDITION OF USE AND SALE</h2>
        <p className="mb-4">
          DIYLEGAL has a right to unilaterally amend the Terms And Conditions and to post an updated or edited version of the Terms And Conditions on the WEBSITE.
        </p>

        <h2 className="text-2xl font-semibold mb-4">ARTICLE 12 - APPLICABLE LAW, LANGUAGE AND THE COMPETENT JURISDICTION PROVISION</h2>
        <p className="mb-4">
          DIYLEGAL is a partnership firm registered in India only and has offices and operations in India only.
        </p>
        <p className="mb-4">
          USER hereby submits to the jurisdiction of India and acknowledges fully that these Terms And Conditions are governed by the laws of the Republic of India (without regard to conflict of law provisions).
        </p>
      </section>
    </div>
  );
}